import React from 'react';
import styled from "styled-components";
import CoinLogo from "../Commons/Currency/CoinLogo.react";
import {formatAsset, formatFiat} from "../../Utilities/utilities";

import ConsolidatedCharts from "./ConsolidatedCharts.react";
import SourcePieCharts from "./SourcePieCharts.react";

const StyledChartCard = styled.div`
  background-color: white;
  min-width: 49.4%;
  height: 40rem;
  margin-bottom: 2rem;
  box-shadow:
    0 2px 2px 0 rgb(0 0 0 / 14%), 
    0 3px 1px -2px rgb(0 0 0 / 12%), 
    0 1px 5px 0 rgb(0 0 0 / 20%);

  .header {
    padding: 2rem 1rem;
    border-bottom: 1px solid #EAEAEA;
    
    .coin-icon {
      height: 100%;
      img {
        height: 100%;
      }
    }
    
    .title {
      display: flex;
      align-items: unset;
      .asset-logo {
        margin-right: 1rem;
        height: 4rem;
      }
      
      .card-title {
        font-size: 2.4rem;
      }
    }
    
    .asset-price {
      font-size: 2.4rem;
      letter-spacing: 1px;
    }
  }
  
  .exchange-breakdown-container {
    display: flex;
    justify-content: space-between;
    height: 9rem;
    margin-top: 1rem;
    padding-left: 2rem;
    padding-right: 2rem;
    
    .holdings-title {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
    
    .exchange-holdings {
      text-align: left;
      .square-blue {
        background-color: #0E7CBF;
        height: 1.5rem;
        width: 1.5rem;
        margin-right: 1rem;
      }
    }
    
    .user-holdings {
      text-align: right;
      .square-green {
        background-color: #0CC087;
        height: 1.5rem;
        width: 1.5rem;
        margin-left: 1rem;
      }
    }
  }
  
  .graph-section {
    margin-top: 1rem;
  }
`

const ChartCard = ({title, assetPrice, asset, graphData, showBySource}) => {
  console.log('showBySource =>', showBySource);
  return (
    <StyledChartCard>
      <div className={'header'}>
        <div className={'title'}>
          <div className={'asset-logo'}>
            {asset && <CoinLogo name={title} code={asset.code} />}
          </div>
          <div className={'card-title'}>{title}</div>
        </div>
        <div className={'asset-price'}>
          {asset && <>{formatAsset(asset.amount)} {asset.code} &#8776;</>} ${formatFiat(assetPrice)}
        </div>
      </div>
      { showBySource ?
        <SourcePieCharts />
        :
        <ConsolidatedCharts graphData={graphData} asset={asset} />
      }
    </StyledChartCard>
  )
}

export default ChartCard;